import { Or2Dialog } from '@/components/feedback/Or2Dialog';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const FileShareOnNoticeboardDialog = ({ open, onClose }: Props) => {
  return (
    <Or2Dialog
      title="Share this file on the noticeboard"
      open={open}
      onClose={onClose}
    >
      Share on noticeboard
    </Or2Dialog>
  );
};
